import React from 'react';
import { useParams, Link } from 'react-router-dom';

function BlogDetail() {
  const { id } = useParams();
  
  const blogs = {
    1: {
      title: "Reflections from the 7th Africa's Business Heroes Finale",
      date: "13-14 December",
      content: [
        "The 7th edition of Africa's Business Heroes (ABH), an initiative by the Jack Ma Foundation, concluded on a truly inspiring note. Attending the finale was more than just participating in an event; it was stepping into a space that represents the future of African entrepreneurship.",
        "The atmosphere was defined by ambition, creativity, and purpose. The room was filled with founders who are not only building businesses, but also designing solutions grounded in a deep understanding of their communities. What stood out most was how these entrepreneurs combine local insight with global best practices, proving that Africa's challenges can be addressed by Africans who understand them best.",
        "The experience offered valuable lessons on building sustainable and scalable business models. It reinforced the importance of job creation and the responsibility entrepreneurs carry in shaping a more equitable and resilient African economy. Beyond funding and recognition, the event emphasized systems thinking, long-term vision, and measurable impact.",
        "One of the most powerful aspects of the finale was the sense of community. Founders, mentors, investors, and industry leaders came together not as competitors, but as collaborators. Ideas were exchanged openly, experiences were shared honestly, and meaningful connections were formed. It became clear that entrepreneurship in Africa is not solely about profitability; it is about solving real problems, expanding economic opportunity, and creating employment for millions.",
        "A special congratulations to Diana Orembe of NovFeed for emerging as the overall winner. Standing out among more than 32,000 applicants is a remarkable achievement and a testament to her talent, resilience, and hard work. Her success is not only personal; it represents possibility. It sends a strong message to young entrepreneurs, especially women across the continent, that vision combined with persistence can lead to extraordinary outcomes.",
        "The 7th ABH finale was a reminder that Africa's entrepreneurial ecosystem is evolving rapidly. The continent is not short of ideas, talent, or courage. What is growing now is structure, collaboration, and scale. And that shift makes all the difference."
      ]
    }
  };

  const blog = blogs[id];

  if (!blog) {
    return (
      <div className="container" style={{padding: '8rem 2rem', textAlign: 'center'}}>
        <h2>Blog not found</h2>
        <Link to="/blogs" className="btn btn-primary" style={{marginTop: '2rem'}}>Back to Blogs</Link>
      </div>
    );
  }

  return (
    <>
      <section className="blog-detail-hero">
        <div className="blog-detail-hero-video">
          <iframe 
            width="100%" 
            height="100%" 
            src="https://www.youtube.com/embed/ttYCPcxcSzE?autoplay=1&mute=1&loop=1&playlist=ttYCPcxcSzE" 
            title="YouTube video player" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        </div>
        <div className="blog-detail-overlay"></div>
        <div className="blog-detail-header">
          <h1>{blog.title}</h1>
          <p className="blog-detail-date">{blog.date}</p>
        </div>
      </section>

      <section className="blog-detail-content">
        <div className="container">
          <Link to="/blogs" className="back-link">← Back to Blogs</Link>
          <article className="blog-article">
            {blog.content.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </article>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
